import { RootState } from "@redux/app/store"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { MapFiltersOil } from "./mapFiltersOilSlice"

const defaultState: MapFiltersOil = {
	facilities: {
		showSurface: false,
		showUnderwater: false,
	},
	fields: {
		showGasCondensate: false,
		showOilGas: false,
		showGas: false,
		showOil: false,
	},
}

export const consumptionMapFiltersOilStorageKey = "consumptionMapFiltersOil" as const

const storedState = localStorage.getItem(consumptionMapFiltersOilStorageKey)
export const initialState: MapFiltersOil =
	storedState !== null ? JSON.parse(storedState) : defaultState

const consumptionMapFiltersOilSlice = createSlice({
	name: "consumptionMapFiltersOil",
	initialState,
	reducers: {
		updateConsumptionMapFiltersOil(state, action: PayloadAction<MapFiltersOil>) {
			localStorage.setItem(consumptionMapFiltersOilStorageKey, JSON.stringify(action.payload))
			return { ...state, ...action.payload }
		},
		resetConsumptionMapFiltersOil(state) {
			localStorage.setItem(consumptionMapFiltersOilStorageKey, JSON.stringify(defaultState))
			return { ...state, ...defaultState }
		},
	},
})

export const { updateConsumptionMapFiltersOil, resetConsumptionMapFiltersOil } =
	consumptionMapFiltersOilSlice.actions

export const getConsumptionMapFiltersOil = (state: RootState) => state.consumptionMapFiltersOil
export default consumptionMapFiltersOilSlice.reducer
